<template>

  <v-app-bar app v-resize="onResize"  :height="header_height"  dark fixed class="bg-blur elevation-0 dm-header" >
     <template v-if="alertnavigate">
         
  <v-app-bar app class="mt-0" height="50"  color="#ffffff" dark fixed >

  <v-menu v-if="$vuetify.breakpoint.xsOnly" >

        <template v-slot:activator="{ on }">
          
         <v-btn  icon  @click="closealertnavigate">
              <v-icon  class="mx-2" color="black">mdi-window-close</v-icon>
            </v-btn>
        
        </template>
      </v-menu>
      <v-row  align="center" >
     
     
   <v-col cols="2"  align="center">
        <div v-if="!$store.getters['isLogin']">
          <v-img
            src="../../assets/logo.png"
            max-height="40"
            max-width="40"
            @click="onClickMenu('/')"
           
          ></v-img>
        </div>
      
         </v-col>
      

  
   
 <v-col cols="7" align="center" class="text-left mt-4 ">
  
 
    <h4 class="black--text ">Dmeets {{this.showOSName}}</h4>
    <p class="black--text  ">Better experience with our app</p>

  </v-col>
   <v-col cols="3"  align="center">
  <template >
    <a :href="linkstore" target="_blank" class="black--text ">
      Download
    </a>
  </template >
 </v-col>
     <!-- <v-toolbar-title  v-if="!$vuetify.breakpoint.xsOnly">Toolbar Mobile Menu</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-sm-and-down">
        <v-btn text to="create">
          <span class="mr-2" v-if="activeUser">Create Post</span>
        </v-btn>
        <v-btn text to="/">
          <span class="mr-2" v-if="activeUser">All Posts</span>
        </v-btn>
      </v-toolbar-items> -->

     </v-row>
    </v-app-bar>
      </template>

    <!-- ===================== แถบเมนูหลัก (UI ใหม่) ===================== -->
    <div class="dm-bar" :class="[heightrowmenu, { 'dm-bar--stacked': isStacked }]">

      <!-- ===== มือถือ (xs): ปุ่มเมนู + โลโก้ ===== -->
      <template v-if="$vuetify.breakpoint.xsOnly">
        <!--
         <v-menu v-if="$vuetify.breakpoint.xsOnly" >

        <template v-slot:activator="{ on }">
          <v-btn  @click="$store.state.navMenuMainpage = !$store.state.navMenuMainpage" icon >
            <v-icon >mdi-reorder-horizontal</v-icon>
          </v-btn>
        </template>
        </v-menu>
        -->
        <v-btn color="#000000"  @click="$store.state.navMenuMainpage = !$store.state.navMenuMainpage" icon >
          <v-icon >mdi-reorder-horizontal</v-icon>
        </v-btn>
        <div class="dm-logo" @click="onClickMenu('/')">
          <img src="../../assets/logo.png" alt="Dmeets" class="dm-logo-img" />
          <span class="dm-logo-text">Dmeets</span>
        </div>
        <span class="dm-xs-spacer"></span>
      </template>

      <!-- ===== จอใหญ่ ===== -->
      <template v-else>
        <!-- โลโก้ -->
        <div v-if="!$store.getters['isLogin']" class="dm-logo" @click="onClickMenu('/')">
          <img src="../../assets/logo.png" alt="Dmeets" class="dm-logo-img" />
          <span class="dm-logo-text">Dmeets</span>
        </div>

        <!-- เมนูกลาง -->
        <nav class="dm-nav" :class="'dm-nav--' + menualign">
          <a class="dm-nav-link" :class="{ 'is-active': isActive('/') }" @click="onClickMenu('/')">
            {{ lg_header_menu.home }}
          </a>
          <!-- text-uppercase -->
          <a class="dm-nav-link" :class="{ 'is-active': isActive('/about') }" @click="onClickMenu('/about')">
            {{ lg_header_menu.about }}
          </a>
          <a class="dm-nav-link" :class="{ 'is-active': isActive('/feature') }" @click="onClickMenu('/feature')">
            {{ lg_header_menu.feature }}
          </a>
          <!-- <a class="dm-nav-link" :class="{ 'is-active': isActive('/pricing') }" @click="onClickMenu('/pricing')">
            {{ lg_header_menu.pricing }}
          </a> -->
          <a class="dm-nav-link" :class="{ 'is-active': isActive('/contact') }" @click="onClickMenu('/contact')">
            {{ lg_header_menu.contact }}
          </a>
        </nav>

        <!-- ปุ่มขวา -->
        <div class="dm-actions">
          <v-btn outlined color="#205295" class="dm-btn" @click="onClickMenu('/joinmeetid')">
            {{ lg_header_menu.joinmeetbyid }}
          </v-btn>

          <button
            v-if="!$store.getters['isLogin']"
            type="button"
            class="dm-btn dm-btn--text"
            @click="onClickMenu('/login-account')"
          >
            {{ lg_header_menu.signin }}
          </button>

          <button
            v-if="!$store.getters['isLogin']"
            type="button"
            class="dm-btn dm-btn--solid"
            @click="onClickMenu('/register-account')"
          >
            {{ lg_header_menu.registerformeeting }}
          </button>

<!-- open-on-hover -->
          <v-menu offset-y>
            <template v-slot:activator="{ attrs, on }">
              <!--  class="positionflag" -->
              <button type="button" class="dm-lang" v-bind="attrs" v-on="on">
                <!-- <country-flag :country="defaultlanguage" size="normal" />  -->
                <v-icon size="16" color="#4b5563">mdi-web</v-icon>
                <span>{{ defaultlanguage }}</span>
                <v-icon size="16" color="#9ca3af">mdi-chevron-down</v-icon>
              </button>
            </template>

            <v-list dense>
              <v-list-item
                v-for="(item,idx) in chooselanguage"
                :key="idx"
                link
                @click="onChange(item.flag)"
              >
                {{ item.full_name }}
                <!-- <country-flag :country="item.flag" size="normal" /> -->
              </v-list-item>
            </v-list>
          </v-menu>

          <v-btn
            v-if="$store.getters['isLogin']"
            icon
            @click.prevent="onClickLogOff"
          >
            <!-- {{ item.full_name }} -->
            <v-icon color="#4b5563">mdi-export</v-icon>
          </v-btn>
        </div>
      </template>
    </div>
     <!-- <v-toolbar-title  v-if="!$vuetify.breakpoint.xsOnly">Toolbar Mobile Menu</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-sm-and-down">
        <v-btn text to="create">
          <span class="mr-2" v-if="activeUser">Create Post</span>
        </v-btn>
        <v-btn text to="/">
          <span class="mr-2" v-if="activeUser">All Posts</span>
        </v-btn>
      </v-toolbar-items> -->
    </v-app-bar>
    
</template>

<script>
import api from "@/services/api";
import { feature } from "../../services/constants";
import SwitchLang from "vue-switch-lang";
import {lg_header_menu} from '../../views/language/lg_header_menu.js';

export default {
  name: "HeaderResponsive",
  data: () => ({
    linkstore:"",
    showOSName:"Unknown OS",
    clickclosenavigate:false,
    alertnavigate:true,
    heightrowmenu:"",
    buttonsizesmall:false,
    iconalign:"left",
    menualign:"left",
    buttonlign:"left",
    defaultlanguage: "",
      // regexlang: "th",
      chooselanguage: [
        { name: "en", flag: "gb",full_name:"English" },
        { name: "th", flag: "th",full_name:"ภาษาไทย" },
      ],
    drawer: false,
    text_fontsize: 30,
    dialog: false,
    mLoc: "center",
    mLoc2: "center",
    header_rotate: "",
    header_mt: "",
    acc_plan: "",
    date_exire: 0,
    role: "",
    id: "",
    menu: [
      { icon: "home", title: "หน้าหลัก" },
      { icon: "info", title: "ฟีเจอร์" },
      { icon: "info", title: "ติดต่อเรา" },
    ],
    initLang: {
      title: "en",
      flag: "gb",
    },
    options: [
      {
        title: "en",
        flag: "gb",
      },
      {
        title: "th",
        flag: "th",
      },
    ],
  }),
  components: {
    SwitchLang
  },
  async mounted() {
   
     this.onResize()
    this.$forceUpdate();
    // this.$router.go(); // Refreshes page

    this.acc_plan = localStorage.getItem("acc_plan");
    this.role = localStorage.getItem("role");
    this.id = localStorage.getItem("user_id");

    // alert(this.id);
    // alert(this.acc_plan);
    // alert(this.role);

    const res = await api.getDateExpire(this.id);

    this.date_exire = res.data.value_expire;
    // alert(this.date_exire);
    // console.log("date_exire : " + this.date_exire);
  },
  computed: {
    // iPad / จอกลาง (600–1099px): เมนูเต็มวางแถวเดียวไม่พอ ให้ปุ่มขวาลงแถวที่ 2
    isStacked() {
      return !this.$vuetify.breakpoint.xsOnly && this.$vuetify.breakpoint.width < 1100;
    },
    version() {
      return process.env.VUE_APP_VERSION;
    },
    title() {
      return process.env.VUE_APP_TITLE;
    },
    width() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 70;
        case "sm":
          return 70;
        case "md":
          return 60;
        case "lg":
          return 70;
        case "xl":
          return 80;
      }
    },
    header_height() {
      if (this.isStacked) {
        return 170;
      }
      if(this.clickclosenavigate == true){
         this.heightrowmenu = "";
switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 70;
        case "sm":
          return 70;
        case "md":
          return 70;
        case "lg":
          return 70;
        case "xl":
          return 70;
           }
      }else{

     
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 120;
        case "sm":
          return 70;
        case "md":
          return 70;
        case "lg":
          return 70;
        case "xl":
          return 70;
           }
      }
    },
  },
  methods: {
    
    onChange(lang) {
      // Do something
      // alert(lang.title);
      // this.defaultlanguage = lang;
      localStorage.setItem(feature.LANGUAGE, lang);
       if(localStorage.getItem(feature.LANGUAGE) == "th"){
      this.defaultlanguage = "ภาษาไทย";
      }else{
        this.defaultlanguage = "English";
      }
      // alert(localStorage.getItem(feature.LANGUAGE));
      // console.log("language header : " + localStorage.getItem(feature.LANGUAGE));
      this.$router.go();
    },
    onResize: function () {
      
      if (this.$vuetify.breakpoint.xsOnly) {
       
        this.iconalign="left";
        this.buttonsizesmall = false;
        if(this.clickclosenavigate !== true){
           this.heightrowmenu = "mt-10";
 this.alertnavigate = true;
        }else{
           this.alertnavigate = false;
        }
      
      }else if(this.$vuetify.breakpoint.smOnly){
          this.alertnavigate = false;
        this.heightrowmenu = "";
         this.menualign="center";
         this.buttonlign="center";
         this.buttonsizesmall = true;
      }
      
       else {
          this.alertnavigate = false;
          this.heightrowmenu = "";
        // this.iconalign="center";
         this.menualign="left";
          this.buttonlign="left";
            this.buttonsizesmall = true;
      }
    },
    closealertnavigate(){
      this.clickclosenavigate=true;
   this.alertnavigate = false;
    },
    onClickLogOff() {
      this.$store.dispatch("doLogout");
      // alert("Test");
    },
    // ใช้ขีดเส้นใต้เมนูหน้าที่เปิดอยู่
    isActive(path) {
      return path === "/" ? this.$route.path === "/" : this.$route.path.startsWith(path);
    },
    onClickMenu(link) {
      this.$store.state.navMenu = false;
      this.$router.push(link).catch((err) => {});
    },
  
    
  },
   async beforeCreate() {

      this.$store.state.page_reload = false;
      // this.defaultlanguage =  localStorage.getItem(feature.LANGUAGE);
      if(localStorage.getItem(feature.LANGUAGE) == "th"){
      this.defaultlanguage = "ภาษาไทย";
      }else{
        this.defaultlanguage = "English";
      }
      // alert(localStorage.getItem("language"))
      // console.log("language login : " + localStorage.getItem(feature.LANGUAGE));

      localStorage.getItem(feature.LANGUAGE) === "th"
        ? this.lg_header_menu = lg_header_menu.lg_header_menu_th
        : this.lg_header_menu = lg_header_menu.lg_header_menu_en;

        // console.log("lg_login: " + JSON.stringify(this.lg_login));
    },
    
  async beforeUpdate(){
 this.onResize()
  },
     async created() {
        if (navigator.userAgent.indexOf("Win") != -1) this.showOSName = "Windows";
  if (navigator.userAgent.indexOf("Mac") != -1) this.showOSName = "Macintosh";
  if (navigator.userAgent.indexOf("Linux") != -1) this.showOSName = "Linux";
  if (navigator.userAgent.indexOf("Android") != -1){
   this.showOSName = "Android";}
  //  https://play.google.com/store/apps/details?id=app.dcm.dmeet&fbclid=IwAR0KEttfME6UpeDSpoV8C_udhLktb1DNou1DcC1dsUuceCgGfBKypSmRgwc
   this.linkstore = "https://play.google.com/store/apps/details?id=com.dcm.dmeetszoom.dcm_dmeetszoom"; 
  if (navigator.userAgent.indexOf("like Mac") != -1){ 
  this.showOSName = "iOS"
  this.linkstore = "https://apps.apple.com/th/app/dmeets/id6479974253"
  };


      this.$store.state.page_reload = false;
  // this.defaultlanguage =  localStorage.getItem(feature.LANGUAGE);
   if(localStorage.getItem(feature.LANGUAGE) == "th"){
      this.defaultlanguage = "ภาษาไทย";
      }else{
        this.defaultlanguage = "English";
      }
  this.onResize()
    },
 
};
</script>

<style scoped>
@media only screen and (max-width: 600px) {
.v-toolbar__content{
  height: 180px;
}
.v-application p {
    font-size: 8px;
}
}
.theme--dark.v-app-bar.v-toolbar.v-sheet {
    /* background-color: #205295; */

}

/* .v-application .positionflag{
    background-color: unset;
    margin-bottom: 0.5rem;
    margin-right: 1rem;
    height: unset;
    box-shadow: none;
} */

.v-application .positionflag{
    padding-bottom: 5px;
    padding-right: 0px;
}

.bg-blur{
    position: fixed;
  /* background-color: #FAFAFA!important; */
    background-color: #FFFFFF!important;
  backdrop-filter: blur(0px) !important;
  -webkit-backdrop-filter: blur(0px) !important; 
  /* z-index: 1000 !important;  */
}


/* ===================== UI ใหม่ตาม Figma ===================== */
.dm-header {
  border-bottom: 1px solid #e5e7eb !important;
}
.dm-header ::v-deep .v-toolbar__content {
  padding: 0;
}
.dm-bar {
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 32px;
  height: 64px;
  display: flex;
  align-items: center;
  gap: 24px;
}
@media (max-width: 599px) {
  .dm-bar { padding: 0 12px; gap: 8px; }
}

/* Logo */
.dm-logo {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  flex-shrink: 0;
}
.dm-logo-img {
  width: 40px;
  height: 40px;
  object-fit: contain;
}
.dm-logo-text {
  font-size: 24px;
  color: #215295;
  line-height: 1;
}
.dm-xs-spacer {
  width: 36px;
  margin-left: auto;
}

/* Nav */
.dm-nav {
  flex: 1;
  min-width: 0;
  white-space: nowrap;
  display: flex;
  align-items: stretch;
  justify-content: center;
  gap: 32px;
  height: 100%;
}
.dm-nav--center { justify-content: center; }
.dm-nav-link {
  display: flex;
  align-items: center;
  height: 100%;
  font-size: 16px;
  font-weight: 400 !important;
  color: #4b5563 !important;
  border-bottom: 2px solid transparent;
  cursor: pointer;
  text-decoration: none;
  transition: color 0.15s ease, border-color 0.15s ease;
}
.dm-nav-link:hover {
  color: #215295 !important;
}
.dm-nav-link.is-active {
  color: #215295 !important;
  border-bottom-color: #215295;
}

/* Actions */
.dm-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
}
.dm-btn {
  font: inherit;
  font-size: 15px;
  padding: 8px 16px;
  border-radius: 8px;
  cursor: pointer;
  white-space: nowrap;
  transition: background-color 0.15s ease;
}
.dm-btn--outline {
  background: #ffffff;
  color: #215295 ;
  border: 1px solid #d1d5db;
}
.dm-btn--outline:hover {
  background: #f9fafb;
}
.dm-btn--text {
  background: transparent;
  color: #111827;
  border: 1px solid transparent;
}
.dm-btn--text:hover {
  color: #215295;
}
.dm-btn--solid {
  background: #215295;
  color: #ffffff;
  border: 1px solid #215295;
  font-weight: 500;
}
.dm-btn--solid:hover {
  background: #1b4580;
}
.dm-lang {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #ffffff;
  font: inherit;
  font-size: 13px;
  color: #4b5563;
  cursor: pointer;
}
.dm-lang:hover {
  background: #f9fafb;
}

/* ===== iPad / จอกลาง: แถว 1 = โลโก้ + เมนู, แถว 2 = ปุ่มขวา ===== */
/* .dm-bar--stacked {
  flex-wrap: wrap;
  height: auto;
  padding: 8px 24px;
  row-gap: 8px;
  column-gap: 24px;
}
.dm-bar--stacked .dm-nav {
  height: 48px;
  gap: 24px;
  justify-content: flex-end;
}
.dm-bar--stacked .dm-actions {
  width: 100%;
  justify-content: center;
  padding-bottom: 4px;
} */
 .dm-bar--stacked {
  flex-direction: column;
  align-items: center;
  height: auto;
  padding: 10px 24px;
  gap: 6px;
}
.dm-bar--stacked .dm-logo {
  justify-content: center;
}
.dm-bar--stacked .dm-nav {
  flex: none;
  width: 100%;
  height: 40px;
  gap: 24px;
  justify-content: center;
}
.dm-bar--stacked .dm-actions {
  width: 100%;
  justify-content: center;
  padding-bottom: 4px;
}

</style>